<div class="alert-layer">
  <button class="backdrop" type="button" tabindex="-1" aria-label="Cerrar alerta" (click)="dismiss()"></button>
  <section #dialog class="alert-dialog" [attr.role]="alert().buttons.length ? 'alertdialog' : 'alert'" aria-modal="true" aria-labelledby="alert-title" aria-describedby="alert-description" tabindex="-1">
    <h2 id="alert-title" class="title">{{ alert().title }}</h2>
    <p id="alert-description" class="description">{{ alert().description }}</p>
    @if (alert().buttons.length) {
      <div class="actions">
        @for (button of alert().buttons; track $index) {
          <app-button [innerId]="'btn-8mQHrpwz-' + $index" [label]="button.label" [styleClass]="button.styleClass ?? (button.role === 'cancel' ? 'secondary small' : 'primary small')" (action)="dismiss(button.role)" />
        }
      </div>
    }
  </section>
</div>
